import { render, staticRenderFns } from "./FinalTicketV2.vue?vue&type=template&id=35891498&scoped=true"
import script from "./FinalTicketV2.vue?vue&type=script&lang=js"
export * from "./FinalTicketV2.vue?vue&type=script&lang=js"
import style0 from "./FinalTicketV2.vue?vue&type=style&index=0&id=35891498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35891498",
  null
  
)

export default component.exports